// extracted by mini-css-extract-plugin
export default {"root":"GuideWidget_root__zNFQE","content":"GuideWidget_content__yNMgL"};